import React from 'react';
import { Container, ContainerProps } from '@mui/material';

interface AppContainerProps extends ContainerProps {
  children?: React.ReactNode;
}

const AppContainer = ({ children, ...props }: AppContainerProps) => {
  return <Container {...props}>{children}</Container>;
};

export default AppContainer;
